// @ts-check
import styled from 'styled-components';
import msTeamsLogoColored from 'images/logos/microsoft-teams-logo.svg';
import { SPACES, PADDING } from 'common/constants/sizes';
import { LBButton } from '@linearb/buzz';

const StyledLogo = styled.img`
  height: ${SPACES.normal};
  width: ${SPACES.normal};
  padding-left: ${PADDING.small};
`;

const MsTeamsConnectButton = ({ clientId = '', ButtonText = '' }) => (
  <LBButton asChild variant='outline'>
    <a href={clientId} target='_blank'>
      <StyledLogo src={msTeamsLogoColored} alt='' />
      {`${ButtonText}`}
    </a>
  </LBButton>
);

export default MsTeamsConnectButton;
